import { GenerateNumbers, onlyUnique } from './ArrayHelper';

interface PageLink {
  type: 'page' | 'break';
  value?: number;
  selected: boolean;
}

/**
 * Creates an array of page options for pagination.
 * Each page option has a type, value, and selected flag.
 * The type can be either 'page' or 'break'.
 * The value represents the page number.
 * The selected flag indicates whether the page is currently selected.
 *
 * @param currentPageNumber - The current page number, not page index.
 * @param totalPages - The total number of pages.
 * @returns An array of page options.
 */
export function createPageLinkOptions(currentPageNumber: number, totalPages: number): PageLink[] {
  const linksBeforeAndAfter = 2;
  const links: PageLink[] = [];
  const pageNumbers = [
    1,
    ...GenerateNumbers(currentPageNumber - linksBeforeAndAfter, currentPageNumber),
    ...GenerateNumbers(currentPageNumber, currentPageNumber + linksBeforeAndAfter),
    totalPages
  ]
    .filter((x) => x > 0 && x <= totalPages)
    .filter(onlyUnique);

  for (let i = 0; i < pageNumbers.length; i++) {
    const page = pageNumbers[i];
    const isSelected = currentPageNumber == page;
    if (i > 0 && page - pageNumbers[i - 1] > 1) {
      links.push({ type: 'break', selected: isSelected });
    }
    links.push({ type: 'page', value: page, selected: isSelected });
  }
  return links;
}
